import React, { useEffect, useState } from "react"
import { Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import SearchSelectBox from "../SearchSelectBox"
import ResultHandler from "../ResultHandler"
import { useResponse } from "../../hooks/useResponse"
import Select from 'react-select'
import { getAdmins } from "../../api/admins"
import { getCompanies } from "../../api/companies"
import { getEmployees } from "../../api/employees"
import { getContracts } from "../../api/contract"
import { assignReservation } from "../../api/reservation"
import { useLocation } from "react-router-dom"

const options = [
  { value: 'admin', label: 'Admin' },
  { value: 'employee', label: 'Employee' },
  { value: 'company', label: 'Company' },
]

const AssignReservationModal = ({type, entity, show, handleClose, handleRefetch}) => {
    const location = useLocation()
    const [selectedOption, setSelectedOption] = useState(null);    
    
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [admin, setAdmin] = useState(null)
    const [employee, setEmployee] = useState(null)
    const [company, setCompany] = useState(null)
    const [contract, setContract] = useState(null)
    const [amount, setAmount] = useState(type == 'room' ? entity?.target_price || '' : entity?.cost_per_day || '')

    useEffect(() => {
      if(location.state?.timeline) {
        setDateFrom(sessionStorage.getItem("clickedDate"))
      }
    }, [])

    const handleOptionChange = (op) => {
      setSelectedOption(op)
      setAdmin(null)
      setEmployee(null)
      setCompany(null)
      setContract(null)
    }
    
    const {loading, error, setData} = useResponse(assignReservation, () => {
        handleRefetch()
        handleClose()
    })

    function handleConfirm(){
      const data = {
        amount,
        car_id: type == 'car' ? entity.id : null,
        room_id: type == 'room' ? entity.id : null,
        admin_id: admin?.id || null,
        employee_id: employee?.id || null,
        contract_id: contract?.id || null,
        startAt: dateFrom,
        endAt: dateTo || null
      }
      setData({type: "add", data })
    }

    return (
      <Modal isOpen={show} toggle={handleClose} centered={true}>
        <ModalBody className="py-5 px-5">
          <Row>
            <Col lg={12}>
              <div className="text-center">
                <h3 className="text-capitalize">assign {type}</h3>
              </div>
            </Col>
          </Row>

          <Row>
              <Col sm={6}>
                <FormGroup className="mt-3">
                  <Label>From</Label>
                  <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup className="mt-3">
                  <Label>To</Label>
                  <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
                </FormGroup>
              </Col>

              <Col md={12}>
                <Label>Assign To</Label>
                <Select
                    options={options}
                    isSearchable={false}
                    value={selectedOption}
                    onChange={handleOptionChange}
                />
              </Col>

              {selectedOption && selectedOption.value == 'admin' && <Col md={12}>
                <FormGroup className="mt-3">
                  <Label>Admin</Label>
                  <SearchSelectBox 
                    type="admins"
                    label='username'
                    api={getAdmins}
                    value={admin?.id || null}
                    setValue={e => setAdmin(e)}
                  />
                </FormGroup>
              </Col>}

              {selectedOption && selectedOption.value == 'employee' && <Col md={12}>
                <FormGroup className="mt-3">
                  <Label>Employee</Label>
                  <SearchSelectBox 
                    type="employees"
                    label='name'
                    api={getEmployees}
                    value={employee?.id || null}
                    setValue={e => setEmployee(e)}
                  />
                </FormGroup>
              </Col>}

              {selectedOption && selectedOption.value == 'company' && <Col md={12}>
                <FormGroup className="mt-3">
                  <Label>Company</Label>
                  <SearchSelectBox 
                    type="companies"
                    label='name'
                    api={getCompanies}
                    value={company?.id || null}
                    setValue={e => {
                      setContract(null)
                      setCompany(e)
                    }}
                  />
                </FormGroup>
              </Col>}

              {selectedOption && selectedOption.value == 'company' && company && <Col md={12} key={company?.id}>
                <FormGroup className="mt-3">
                  <Label>Contract</Label>
                  <SearchSelectBox 
                    type="company_contracts"
                    label='jobTitle'
                    api={getContracts}
                    apiMeta={{companyId: company?.id}}
                    value={contract?.id || null}
                    setValue={e => setContract(e)}
                  />
                </FormGroup>
              </Col>}

              {admin || employee || contract ? <Col md={12}>
                <FormGroup className="mt-3">
                  <Label>Amount E</Label>
                  <Input type="text" value={amount} onChange={(e) => setAmount(e.target.value)} />
                </FormGroup>
              </Col>: ""}

              <ResultHandler error={error} />
          </Row>

          <Row>
            <Col>
              <div className="text-center mt-4">
                {!loading && <button
                  type="button"
                  className="btn btn-primary btn-lg ms-2"
                  onClick={handleConfirm}
                  disabled={(!admin && !employee && !contract) || !dateFrom}
                  >
                  Assign
                </button>}

                {loading && <button
                  type="button"
                  className="btn btn-dark btn-lg ms-2"
                >
                  Wait...
                </button>}

                <button
                  type="button"
                  className="btn btn-secondary btn-lg ms-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
  )
}

export default AssignReservationModal
